import {Edition} from "./Edition";

export class Article {
    constructor(state) {

        if (state == null)
            state = {};

        const { id = 0, editionId = null, occhiello = '', title = '', summary = '', signature = '', text = '', pageFrom = null, pageTo = null, isOnline = false, edition = null } = state;

        this.id = id;
        this.editionId = editionId;
        this.occhiello = occhiello;
        this.title = title;
        this.summary = summary;
        this.signature = signature;
        this.text = text;
        this.pageFrom = pageFrom;
        this.pageTo = pageTo;
        this.category = new Category();
        this.tags = [];
        this.isOnline = isOnline;
        this.edition = edition
    }
}

export class Category{
    id= 0;
    name = '';
    slug = '';
    macroCategory = new MacroCategory();
}

class MacroCategory {
    id = 0;
    name = '';
    slug = '';
}



// WEBPACK FOOTER //
// ./src/Models/Article.js